<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">掲載商品検索</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <h2>検索条件</h2>
          <div class="element-column">
            <div class="column-list">
              <label class="list-input-title">受注コード</label>
              <div class="list-input-content">
                <app-order-code-text-input id="txt_OrderCodeFrom" #txt_OrderCodeFrom [subid]="'txt_OrderCodeFrom'"
                  [(ngModel)]="kymw1403Model.orderCodeFrom" [required]="true" [catalogIDField]="lbl_OrderCodeFrom"
                  [initFocusItem]="txt_OrderCodeFrom" [forcedEnabledMode]="'true'" [tabindex]="0" [maxlength]="7">
                </app-order-code-text-input>
                <label>～</label>
                <app-order-code-text-input id="txt_OrderCodeTo" #txt_OrderCodeTo [subid]="'txt_OrderCodeTo'"
                  [(ngModel)]="kymw1403Model.orderCodeTo" [required]="true" [catalogIDField]="lbl_OrderCodeTo"
                  [initFocusItem]="txt_OrderCodeFrom" [forcedEnabledMode]="'true'" [tabindex]="0" [maxlength]="7">
                </app-order-code-text-input>
              </div>

              <label class="list-input-title">配達企画回(翌週)</label>
              <div class="list-input-content">
                <input type="text" id="lbl_OrderCodeFrom" #lbl_OrderCodeFrom class="deliv-catalog" readonly>
                <label>～</label>
                <input type="text" id="lbl_OrderCodeTo" #lbl_OrderCodeTo class="deliv-catalog" readonly>
              </div>

              <label class="list-input-title">Ｐコード</label>
              <div class="list-input-content">
                <input type="text" class="pcode" id="txti_pCode" [(ngModel)]="kymw1403Model.pCode" plessInputTextSub
                  [restrict]="'[P0-9]'" [maxlength]="8" forcedEnabledMode="true" [tabindex]="0">
              </div>

              <label class="list-input-title">商品案内用商品名</label>
              <div class="list-input-content">
                <app-text-input id="txti_guideGoodsName" class="guide-goods-name" [subid]="'txti_guideGoodsName'"
                  [(ngModel)]="kymw1403Model.guideGoodsName" [restrict]="'[ -￮]'" [fullOnly]="true"
                  [displayCountField]="false" [forcedEnabledMode]="'true'" [tabindex]="0">
                </app-text-input>
              </div>

              <label class="list-input-title">会員生協</label>
              <div class="list-input-content">
                <app-checkbox-label [label]="'い'" id="chb_Ibaraki" [subid]="'chb_Ibaraki'" [forcedEnabledMode]="'true'"
                  [(ngModel)]="kymw1403Model.chbIbaraki" [tabindex]="0">
                </app-checkbox-label>
                <app-checkbox-label [label]="'と'" id="chb_Tochigi" [subid]="'chb_Tochigi'" [forcedEnabledMode]="'true'"
                  [(ngModel)]="kymw1403Model.chbTochigi" [tabindex]="0"> 
                </app-checkbox-label>
                <app-checkbox-label [label]="'ぐ'" id="chb_Gunma" [subid]="'chb_Gunma'" [forcedEnabledMode]="'true'"
                  [(ngModel)]="kymw1403Model.chbGunma" [tabindex]="0">
                </app-checkbox-label>
                <app-checkbox-label [label]="'ち'" id="chb_Chiba" [subid]="'chb_Chiba'" [forcedEnabledMode]="'true'"
                  [(ngModel)]="kymw1403Model.chbChiba" [tabindex]="0">
                </app-checkbox-label>
                <app-checkbox-label [label]="'さ'" id="chb_Saitama" [subid]="'chb_Saitama'" [forcedEnabledMode]="'true'"
                  [(ngModel)]="kymw1403Model.chbSaitama" [tabindex]="0">
                </app-checkbox-label>
                <app-checkbox-label [label]="'とう'" id="chb_Tokyo" [subid]="'chb_Tokyo'" [forcedEnabledMode]="'true'"
                  [(ngModel)]="kymw1403Model.chbTokyo" [tabindex]="0">
                </app-checkbox-label>
                <app-checkbox-label [label]="'な'" id="chb_Nagano" [subid]="'chb_Nagano'" [forcedEnabledMode]="'true'"
                  [(ngModel)]="kymw1403Model.chbNagano" [tabindex]="0">
                </app-checkbox-label>
                <app-checkbox-label [label]="'に'" id="chb_Niigata" [subid]="'chb_Niigata'" [forcedEnabledMode]="'true'"
                  [(ngModel)]="kymw1403Model.chbNiigata" [tabindex]="0">
                </app-checkbox-label>
                <app-checkbox-label [label]="'ク'" id="chb_Kuruco" [subid]="'chb_Kuruco'" [forcedEnabledMode]="'true'"
                  [(ngModel)]="kymw1403Model.chbKuruco" [tabindex]="0">
                </app-checkbox-label>
              </div>
            </div>
            <button id="btn_Search" class="btn-secondary" forcedEnabledMode="true"
            (click)="eventBtnSearch_CLICKHandler()" [tabindex]="0">検索</button>
          </div>
          <div>
            <div class="action-area">
              <app-pager [prevDisabled]="kymw1403Model.disabledPreviousButton"
                [nextDisabled]="kymw1403Model.disabledNextButton" [totalNum]="kymw1403Model.totalNum"
                [startNum]="kymw1403Model.startDispNum" [endNum]="kymw1403Model.endDispNum"
                (prevHandler)="eventBtnBack_CLICKHandler()" (nextHandler)="eventBtnNext_CLICKHandler()">
              </app-pager>
            </div>
            <!-- データグリッド定義 -->
            <wj-flex-grid id="dg_SearchResult" #dg_SearchResult [itemsSource]="kymw1403Model.publishGoodsArray"
              [isReadOnly]="true" [allowDragging]="'None'" [deferResizing]="false" [headersVisibility]="'Column'"
              [selectionMode]="'Row'" [allowSorting]="false" (click)="eventDgSearchResult_HEADERRELEASEHandler($event)"
              forcedEnabledMode="true" [tabindex]="0">
              <!-- 表示項目 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'受注コード'" [binding]="'OrderCode'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'配達企画回'" [binding]="'DelivCatalogId'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'媒体'" [binding]="'MediumName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="110" [header]="'会員生協'" [binding]="'PlanCoopName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="95" [header]="'ページＮＯ'" [binding]="'PageNum'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'ページ名'" [binding]="'PageInfo'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'Ｐコード'" [binding]="'Pcode'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="297" [header]="'商品名'" [binding]="'GuideGoodsName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="283" [header]="'規格名'" [binding]="'GuideStandardName'">
              </wj-flex-grid-column>

              <!-- 非表示項目 -->
              <wj-flex-grid-column [minWidth]="5" [header]="'媒体区分'" [binding]="'MediumType'" [visible]="false">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'会員生協コード'" [binding]="'CoopCode'" [visible]="false">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'ページＩＤ'" [binding]="'PageId'" [visible]="false">
              </wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>
      </div>
      <div class="window-title-close">
        <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
        <button [tabindex]="0" (click)="onClickClose()"></button>
      </div>
      <div cdkDragHandle class="drag-subwindow-bottom-area"></div>
    </td>
  </tr>
</table>